import { render, staticRenderFns } from "./Job-Dashboard.vue?vue&type=template&id=1c482898&scoped=true"
import script from "./Job-Dashboard.vue?vue&type=script&lang=js"
export * from "./Job-Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Job-Dashboard.vue?vue&type=style&index=0&id=1c482898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c482898",
  null
  
)

export default component.exports